// authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { authServie } from "../../services/authService";
import { toast } from "react-toastify";

// initial state for authentication
const initialState = {
  user: null,
  loading: false,
  resendLoading: false,
  emailSent: false,
  error: null,
  isUserVerified: false,
  active: false,
};

// An asynchronous thunk for the login
export const login = createAsyncThunk(
  "user/login",
  async ({ user, navigate }, { rejectWithValue }) => {
    try {
      const response = await authServie.login(user);
      const responseData = response?.data;
      toast.success(responseData?.message);
      navigate("/admin");
      return responseData?.data;
    } catch (error) {
      const responseData = error?.response?.data;
      toast.error(responseData?.message);
      return rejectWithValue(responseData);
    }
  }
);

// An asynchronous thunk for the reset password
export const forgotPassword = createAsyncThunk(
  "user/forgotPassword",
  async ({ data, navigate }, { rejectWithValue }) => {
    try {
      const response = await authServie.forgotPassword(data);
      const responseData = response?.data;
      toast.success(responseData?.message);
    } catch (error) {
      const responseData = error?.response?.data;
      toast.error(responseData?.message);
    }
  }
);

// An asynchronous thunk for the reset password
export const resetPassword = createAsyncThunk(
  "user/resetPassword",
  async ({ data, token, navigate }, { rejectWithValue }) => {
    try {
      const response = await authServie.resetPassword({ data, token });
      const responseData = response?.data;
      toast.success(responseData?.message);
      navigate("/");
    } catch (error) {
      const responseData = error?.response?.data;
      toast.error(responseData?.message);
      navigate("/");
    }
  }
);

// An asynchronous thunk for the deactivate forgot password
export const deactivateForgotPassword = createAsyncThunk(
  "user/deactivateForgotPassword",
  async ({ token, navigate }, { rejectWithValue }) => {
    try {
      const response = await authServie.deactivateForgotPassword(token);
      const responseData = response?.data;
      toast.success(responseData?.message);
      navigate("/");
    } catch (error) {
      const responseData = error?.response?.data;
      toast.error(responseData?.message);
      navigate("/");
    }
  }
);

// Create the authentication slice
const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logoutUser: (state, action) => {
      state.user = null;
      state.active = false;
    },
    handleUserActiveStatus: (state, action) => {
      state.active = action.payload;
    },
    logoutUser: (state, action) => {
      state.user = null;
      state.active = action.false;
    },
    handleProfileImage: (state, action) => {
      state.user.profile_path = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        state.active = true;
        localStorage.setItem("logoutTimer", 60);
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(forgotPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(forgotPassword.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(forgotPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(resetPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(deactivateForgotPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deactivateForgotPassword.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deactivateForgotPassword.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

// Export the authentication actions and reducer
export const { logoutUser, handleProfileImage, handleUserActiveStatus } =
  authSlice.actions;
export default authSlice.reducer;
